import axios, { AxiosResponse, AxiosRequestConfig } from "axios";
import { camelizeKeys, decamelizeKeys } from "humps";
import { requestCsrfInterceptor } from "../auth/csrf";

const WizardAPI = axios.create({
  baseURL: process.env.REACT_APP_API_NEW_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Endpoints that are publicly readable — a 401 from these must not trigger a /login redirect.
const PUBLIC_PATHS = [
  "/v4/status/all",
  "/health",
  "/version",
];

const isPublicEndpoint = (url: string | undefined): boolean => {
  if (!url) return false;
  return PUBLIC_PATHS.some((p) => url.includes(p));
};

const responseErrorInterceptor = (error: any) => {
  const status = error.response?.status;
  const url: string | undefined = error.config?.url;
  if (
    status === 401 &&
    window.location.pathname !== "/login" &&
    !isPublicEndpoint(url)
  ) {
    window.location.href = "/login";
  }
  return Promise.reject(error);
};

const responseCamelizeInterceptor = (response: AxiosResponse) => {
  if (response.data) {
    response.data = camelizeKeys(response.data);
  }
  return response;
};

const requestDecamelizeInterceptor = (config: AxiosRequestConfig) => {
  const newConfig = { ...config };
  newConfig.url = config.url;
  if (newConfig.headers["Content-Type"] === "multipart/form-data")
    return newConfig;
  if (config.params) {
    newConfig.params = decamelizeKeys(config.params);
  }
  if (config.data) {
    newConfig.data = decamelizeKeys(config.data);
  }
  return newConfig;
};

WizardAPI.interceptors.request.use(requestCsrfInterceptor);
WizardAPI.interceptors.request.use(requestDecamelizeInterceptor);
WizardAPI.interceptors.response.use((response) => response, responseErrorInterceptor);
WizardAPI.interceptors.response.use(responseCamelizeInterceptor);

export { WizardAPI };
